import { render, staticRenderFns } from "./GeneTherapy.vue?vue&type=template&id=4b8b510a&scoped=true&"
var script = {}
import style0 from "./GeneTherapy.vue?vue&type=style&index=0&id=4b8b510a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b510a",
  null
  
)

export default component.exports